/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SharedHeadScriptTags_metadata$ref: FragmentReference;
export type SharedHeadScriptTags_metadata = {|
  +microdata: ?string,
  +$refType: SharedHeadScriptTags_metadata$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SharedHeadScriptTags_metadata",
  "type": "MetaData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "microdata",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b1b4576dd4c2a4a6bbd5990cb11c9cf0';
module.exports = node;
